import React from "react";
import CommonLayout from "../../../layouts/commonLayout/CommonLayout";
import CusomizeCalender from "./calender/CusomizeCalender";

function MakeAppointment() {
  return (
    <CommonLayout>
      <div className="mt-4">
        <CusomizeCalender />
      </div>
    </CommonLayout>
  );
}

export default MakeAppointment;
